<div
    class="stat-item position-relative"
    [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h5>
        Daily Production
    </h5>
    <div class="number lh-1 fw-medium">
        45.32 kWh
    </div>
    <span class="daxa-up-down-badge position-relative">
        <i class="material-symbols-outlined">
            trending_up
        </i>
        2.15%
    </span>
    <div class="chart">
        <div id="crm_new_users_chart"></div>
        <div class="title d-block text-body">
            This Week
        </div>
    </div>
</div>